import './productDescription.scss';

import DescriptionGovIncentive from './DescriptionGovIncentive';
import ProductSubTitle from './ProductSubTitle';
import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { ProductPreviewVisao } from './previewGallery/ProductPreviewVisao';
import { useTranslation } from 'react-i18next';

import ModalProductPreviewVisao from './previewGallery/ModalProductPreviewVisao';
import useMobileDetect from '../../hooks/useMobileDetect';

type ProductDescriptionProps = {
    product: Queries.ProductJsonTemplateFragment;
};

export default function ProductDescription(props: ProductDescriptionProps) {
    const { product } = props;
    const { currentLocale } = usePageLocalization();
    const isAndroid = useMobileDetect().isAndroid();
    const productDescription = product.description?.[currentLocale]
        ? (product.description?.[currentLocale] as string)
        : '';

    const { t } = useTranslation('templatePages');

    const [showModal, setShowModal] = useState<boolean>(false);
    const visaoId =
        props.product.attributes?.visao_id?.values?.[0]?.[currentLocale] ?? '';

    const navigateToVisaoPage = (visaoId: string) => {
        const lang = currentLocale === 'fr_CA' ? 'fr' : 'en';
        const a: HTMLAnchorElement = document.createElement('a');
        a.target = '_blank';
        a.href = `https://demo.visao.ca/viewer/${visaoId}?lang=${lang}&ar=true`;
        a.click();
    };

    const startAR = () => {
        if (isAndroid) {
            navigateToVisaoPage(visaoId!);
        } else {
            setShowModal(true);
        }
    };

    return (
        <div className='product-description'>
            <ModalProductPreviewVisao
                isOpen={showModal}
                visaoId={visaoId}
                isStartAR={showModal}
                handleModalClose={() => setShowModal(false)}
                product={product}
            />
            <ProductSubTitle textKey='description-title' />
            <div className='product-description-container-desktop'>
                <div>
                    {product?.description && (
                        <div className='description'>
                            <ReactMarkdown>{productDescription}</ReactMarkdown>
                        </div>
                    )}
                    {!product.category
                        ?.toLowerCase()
                        .includes('wood inserts') && (
                        <div
                            className='button century-product-gallery-visao-button century-hover-blue-button'
                            onClick={() => startAR()}
                        >
                            {t('see-product-space')}
                        </div>
                    )}

                    <DescriptionGovIncentive />
                </div>
                <ProductPreviewVisao
                    visaoId={visaoId}
                    product={props.product}
                />
            </div>
            <div className='product-description-container-mobile'>
                {product?.description && (
                    <div className='description'>
                        <ReactMarkdown>{productDescription}</ReactMarkdown>
                    </div>
                )}
                <ProductPreviewVisao
                    visaoId={visaoId}
                    product={props.product}
                />
                <div
                    className='button century-product-gallery-visao-button century-hover-blue-button'
                    onClick={() => startAR()}
                >
                    {t('see-product-space')}
                </div>
                <DescriptionGovIncentive />
            </div>
        </div>
    );
}
